document.addEventListener('DOMContentLoaded', () => {
	const handleTabClick = (clickedButton) => {
		const specialtyId = clickedButton.dataset.specialtyId;
		const panelId = clickedButton.getAttribute('aria-controls');
		const catalog = clickedButton.closest('.procedure-links');

		const allButtons = catalog.querySelectorAll('.specialty-button');
		allButtons.forEach((btn) => {
			const isActive = btn.dataset.specialtyId === specialtyId;
			btn.classList.toggle('active', isActive);
			btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
		});

		const allPanels = catalog.querySelectorAll('.procedures');
		allPanels.forEach((panel) => {
			const shouldShow = panel.id === panelId;
			panel.classList.toggle('active', shouldShow);
			if (shouldShow) {
				panel.removeAttribute('hidden');
			} else {
				panel.setAttribute('hidden', '');
			}
		});
	};

	const specialtyButtons = document.querySelectorAll(
		'.procedure-links .specialty-button'
	);
	specialtyButtons.forEach((button) => {
		button.addEventListener('click', () => handleTabClick(button));
	});

	// const activeProcedure = document.querySelector(
	// 	'.procedure-links .procedure-link-item.active'
	// );
	// const activeSpecialty = document.querySelector(
	// 	'.procedure-links .specialty-button.active'
	// );

	// const prefersReducedMotion = window.matchMedia(
	// 	'(prefers-reduced-motion: reduce)'
	// ).matches;

	// if (activeSpecialty) {
	// 	setTimeout(() => {
	// 		activeSpecialty.scrollIntoView({
	// 			behavior: prefersReducedMotion ? 'auto' : 'smooth',
	// 			inline: 'end',
	// 			block: 'end',
	// 		});
	// 	}, 300);
	// }

	// if (activeProcedure) {
	// 	setTimeout(() => {
	// 		activeProcedure.scrollIntoView({
	// 			behavior: prefersReducedMotion ? 'auto' : 'smooth',
	// 			inline: 'end',
	// 			block: 'end',
	// 		});
	// 	}, 300);
	// }
});
